import * as React from 'react';
import moment from 'moment';

import { connect } from 'react-redux';

import ListProductionView from 'list-production.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IProduction, IPerformance } from '../../custom/classes/production';
import { RevealPanel } from '../../../../Static/javascript/Content/modules/revealPanel';
interface IListProductionExternalProps {
    production: IProduction;
}

interface StateToProps {
    text: IPackageListingAppText;
    filterFunction: (option) => any;
}

interface ListProductionViewState {
    showPerformances: boolean;
    showSynopsis: boolean;
}

interface ViewProps {
    toggleShowPerformances: () => void;
    toggleShowSynopsis: () => void;
    filteredPerformances: Array<IPerformance>;
}

export type ListProductionProps = IListProductionExternalProps & StateToProps;

export type CombinedProductionViewProps = ListProductionProps & ListProductionViewState & ViewProps;

export class ListProductionBase extends React.Component<ListProductionProps, ListProductionViewState> {

    constructor(props: ListProductionProps) {
        super(props);

        this.state = {
            showPerformances: false,
            showSynopsis: false
        };
    }
    render() {
        const filteredPerformances = this.props.production.performances.filter(this.props.filterFunction);
        if (filteredPerformances.length == 0)
            return null;

        return (
            <ListProductionView {...this.props} {...this.state} filteredPerformances={filteredPerformances}
                toggleShowPerformances={this._toggleShowPerformances.bind(this)}
                toggleShowSynopsis={this._toggleShowSynopsis.bind(this)}
            />
        )
    }

    _toggleShowPerformances = () => {
        this.setState(
            { showPerformances: !(this.state.showPerformances) }
        );
    }

    _toggleShowSynopsis= () => {
        this.setState(
            { showSynopsis: !(this.state.showSynopsis) }
        );
    }

    _activateRevealPanels = () => {
        const revealPanelEls = [].slice.call(document.querySelectorAll('[data-subs-panel]')) as Array<HTMLElement>;
        revealPanelEls.forEach(panelEl => {
            new RevealPanel(panelEl.id);
        });
    }

    componentDidUpdate() {
        this._activateRevealPanels();
    }

    componentDidMount() {
        this._activateRevealPanels();
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListProductionExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        filterFunction: state.packageListing.filterFunction
    }
}

export default connect<StateToProps>(mapStateToProps)(ListProductionBase);